// Vendors
import $ from 'jquery';

const $tagFilter = $('.tribe-filter-bar-c-pill__pill-label:contains("Tags")');
const $tagLegend = $(
  '.tribe-filter-bar-c-filter__filters-legend:contains("Tags")'
);

if ($tagFilter.length > 0) {
  $tagFilter.text('Region');
  $tagLegend.text('Region');
}

// Automatically switch to list view when searching
$('body').on('click', '.tribe-events-c-search__button', function () {
  let attemptCount = 0;
  const maxAttempts = 10;

  const checkForTribeBarSearch = function () {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.has('tribe-bar-search');
  };

  const checkLoading = function () {
    if (
      $('.tribe-events-view-loader').hasClass('tribe-common-a11y-hidden') &&
      checkForTribeBarSearch()
    ) {
      // Attempt to switch to list view
      $('.tribe-events-c-view-selector__list-item--list a').trigger('click');
      setTimeout(checkViewSwitched, 500); // Check if the view has switched
    } else {
      if (attemptCount < maxAttempts) {
        setTimeout(checkLoading, 500); // Retry checking loading
        attemptCount++;
      }
    }
  };

  const checkViewSwitched = function () {
    if (
      $('.tribe-events-c-view-selector__list-item--month').hasClass(
        'tribe-events-c-view-selector__list-item--active'
      )
    ) {
      if (attemptCount < maxAttempts && checkForTribeBarSearch()) {
        $('.tribe-events-c-view-selector__list-item--list a').trigger('click'); // Retry switching to list view
        setTimeout(checkViewSwitched, 500); // Check again
        attemptCount++;
      }
    }
  };

  // Initial call to start the process
  // Wait for a moment before starting to ensure URL has been updated
  setTimeout(() => {
    checkLoading();
  }, 100);
});
